/**
 * External Dependencies
 */
import 'jquery';

import 'slick-carousel/slick/slick.min';
import baguetteBox from 'baguettebox.js';


$(document).ready(() => {
  $('.css-carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    draggable: false,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: true,
          arrows: false,
          variableWidth: true
        }
      }
    ]
  });

  $('.css-standalone').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    draggable: false,
  });

  $('#hero-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
    pauseOnFocus: false,
    speed: 800,
    fade: true,
    cssEase: 'ease-in-out'
  });

  baguetteBox.run('.image-slider', {
    captions: function(element) {
      const captions = element.querySelector('.image-slider__captions');

      if (captions == null) return "";

      return captions.innerHTML;
    },
  });

  const menuButton = $('.navigation-mobile-trigger');
  menuButton.click(() => {
    document.body.classList.toggle('navigation-mobile-active');
  })
});


$(window).on('scroll', function () {
  if ($(window).scrollTop() > 50) {
    $('body').addClass('page-scrolled');
  } else {
    //remove the background property so it comes transparent again (defined in your css)
    $('body').removeClass('page-scrolled');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function updateBodyClass() {
      let activePage = document.querySelector("#contact-us .wpforms-page:not([style*='display: none'])");

      if (activePage) {
          let pageClass = activePage.classList.contains("wpforms-page-1") ? "contact-form-step-1" : "contact-form-step-2";
          document.body.classList.remove("contact-form-step-1", "contact-form-step-2");
          document.body.classList.add(pageClass);
      } else {
          document.body.classList.remove("contact-form-step-1", "contact-form-step-2");
      }
  }
  
  updateBodyClass();
  
  const observer = new MutationObserver(updateBodyClass);
  
  observer.observe(document.querySelector("#contact-us .wpforms-container"), {
      attributes: true,
      subtree: true,
      attributeFilter: ["style"],
  });
});